/*
*
* File JS componente accordion
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './accordion.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const accordion = () => {
    /**
    *	buttonsAccordion --> Tutti i pulsanti per l'apertura degli accordion toggle
    */

    let buttonsAccordion = document.querySelectorAll('.title-accordion-open');
    if(!buttonsAccordion) return;

    
    /* Funzione di gestione apertura e chiusura degli accordion toggle */
    const manageAccordion = (button, dataAccordion, accordionToOpen, heightAccordionContent) => {
        if (accordionBreakpoint(button))
        {
            if(button.classList.contains('open'))
            {   
                button.classList.remove('open');
                accordionToOpen.classList.remove('open');
                accordionToOpen.style.height = '0px';
            }
            else
            {
                if (!dataAccordion == 'dichiarazione-accordion')
                {
                    closeAllAccordion();
                }

                button.classList.add('open');
                accordionToOpen.classList.add('open');
                accordionToOpen.style.height = heightAccordionContent + 'px';
            }
        }
    }

    
    /* Funzione di gestione apertura e chiusura degli accordion toggle */
    const accordionBreakpoint = (accordion) => {
        var dataBreakpoint = accordion.getAttribute('data-breakpoint');

        if (dataBreakpoint == null) return true;

        if (dataBreakpoint.length)
        {
            var breakpoints = JSON.parse(dataBreakpoint);

            for (var i = 0; i < breakpoints.length; ++i) 
            {
                if (window.innerWidth >= breakpoints[i][0] && window.innerWidth <= breakpoints[i][1]) return true;
            }
        }

        return false;
    }

    /* Funzione chiusura di tutti gli accordion  */
    const closeAllAccordion = () => {
        for (var i = 0; i < buttonsAccordion.length; ++i) 
        {
            if (accordionBreakpoint(buttonsAccordion[i]))
            {
                var dataAccordion = buttonsAccordion[i].getAttribute('data-accordion');
                var accordionToOpen = document.querySelector('.content-accordion[data-accordion="' + dataAccordion + '"]');

                if (dataAccordion == null || accordionToOpen == null)
                {
                    dataAccordion = '';
                    accordionToOpen = buttonsAccordion[i].nextElementSibling;
                }

                buttonsAccordion[i].classList.remove('open');
                accordionToOpen.classList.remove('open');
                accordionToOpen.style.height = '';
            }
        }
    }

    /* Funzione per il reset degli elementi al resize  */
    const resetAccordion = () => {
        for (var i = 0; i < buttonsAccordion.length; ++i) 
        {
            if (!accordionBreakpoint(buttonsAccordion[i]))
            {
                var dataAccordion = buttonsAccordion[i].getAttribute('data-accordion');
                var accordionToOpen = document.querySelector('.content-accordion[data-accordion="' + dataAccordion + '"]');

                if (dataAccordion == null || accordionToOpen == null)
                {
                    dataAccordion = '';
                    accordionToOpen = buttonsAccordion[i].nextElementSibling;
                }

                buttonsAccordion[i].classList.remove('open');
                accordionToOpen.classList.remove('open');
                accordionToOpen.style.height = '';
            }
        }
    }

    /* Funzione per il ricalcolo delle altezze al resize */
    const recalcAccordionHeights = () => {
        var accordionOpened = document.querySelectorAll('.content-accordion.open');

        if (accordionOpened.length)
        {
            for (var i = 0; i < accordionOpened.length; ++i) 
            {
                var newHeightAccordionContent = accordionOpened[i].children[0].offsetHeight;
                accordionOpened[i].style.height = newHeightAccordionContent + 'px';
            }
        }
    }

    buttonsAccordion.forEach(el => {
        el.addEventListener('click', function() 
        {
            let dataAccordion = this.getAttribute('data-accordion');
            var accordionToOpen = document.querySelector('.content-accordion[data-accordion="' + dataAccordion + '"]');
            let heightAccordionContent = null;

            if (dataAccordion == null || accordionToOpen == null)
            {
                dataAccordion = '';
                accordionToOpen = el.nextElementSibling;
            }
            
            heightAccordionContent = accordionToOpen.querySelector('div[data-wrapper-height]').offsetHeight;

            manageAccordion(this, dataAccordion, accordionToOpen, heightAccordionContent);

            if (dataAccordion == 'dichiarazione-accordion')
            {
                setTimeout(recalcAccordionHeights, 400);
            }
        });
    });


    /* Funzione chiusura all'esc  */
    const resetAccordionOnKeyup = (e) => {
        if(e.keyCode === 27)
        {
            closeAllAccordion();
        }
    }


    window.onresize = function() {
        resetAccordion();
        recalcAccordionHeights();
    }

    document.addEventListener('keyup', resetAccordionOnKeyup);

}



export default accordion;

//--------------------------------------------------------------------//